export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                </h1>
                <button
                  data-id="410d5405-c8d8-4e9c-bef7-366adade74d8"
                  data-color="515928"
                  className='btn btn-custom btn-lg page-scroll bookitone-booking-init mt-2 booking-button'
                  style={{marginTop: '40px', fontWeight: 800, border: "2px white solid"}}
                >
                  Zarezerwuj swoją przygodę
                </button>{' '}
                
              </div> 
            
              <div className="col-md-6 pb-4 " style={{paddingBottom: '8rem', marginTop: '200px'}}>
                <div className="mx-4 mb-8">
                <img src="/img/strzelnica.jpg" style={{width:'100%'}}/>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
